// extracted by mini-css-extract-plugin
export default {"accordion-title":"Accordion_accordion-title__IDOvS","accordion-content-text":"Accordion_accordion-content-text__OjZsZ"};